import { useMutation } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { displayErrorToast } from "@/utils/toast";

export interface ValidateEmailRequest {
  email: string;
}

export interface ValidateEmailResponse {
  success: boolean;
  valid: boolean;
  requires_sso?: boolean;
  organization_id?: string;
  organization_name?: string;
  authorization_url?: string;
}

export const useValidateEmail = () =>
  useMutation<ValidateEmailResponse, Error, ValidateEmailRequest>({
    mutationFn: async (data: ValidateEmailRequest): Promise<ValidateEmailResponse> =>
      fetch(ENDPOINTS.auth.validate_email, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }).then(handleResponse),
    onError: error => {
      displayErrorToast(error || "Failed to validate email");
    },
  });
